module.exports = __webpack_public_path__ + "static/placeholder-f313803e9280167e44cd23dd4bb0f7ec.jpg";